import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  KeyboardAvoidingView,
} from 'react-native';
import {
  Button,
  Input,
  Icon,
  Text,
} from 'react-native-elements';
import { Formik } from 'formik';
import {
  object as yupObject,
} from 'yup';
import Auth from '@aws-amplify/auth';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';
import Header from '../../misc/Header';

import { translate } from '../../../locales/i18n';
import styles from '../../../styles';
import {
  emailValidation, passwordValidation, password2Validation, codeValidation,
} from '../../../modules/validation/User';

const validationSchema = yupObject().shape({
  email: emailValidation,
  password: passwordValidation,
  password2: password2Validation,
  code: codeValidation,
});

class ForgotSubmitForm extends React.Component {
  constructor(props, context) {
    super(props, context);

    const { email } = props;

    this.state = {
      email,
      error: '',
    };
  }

  // TODO(clairbee): move auth to 'ForgotSubmit.js'; keep only UI stuff here
  onSubmit = (values, formikBag) => {
    const { history, redirect } = this.props;
    const { code, password } = values;
    let { email } = values;

    email = email.trim();

    formikBag.setSubmitting(true);
    this.setState({ error: undefined });

    // FIXME(clairbee): move all 'meat' to the 'ForgotSubmit' class
    Auth.forgotPasswordSubmit(email, code, password)
      .then((_data) => {
        history.push(`/signin${redirect}`);
      })
      .catch((err) => {
        console.log(err);
        let error = err.message || '';
        if (err.code === 'LimitExceededException') {
          error = translate('signin_error_limit');
        }
        this.setState({ email, error });
        formikBag.setSubmitting(false);
      });
  };

  renderForm = ({
    isValid,
    values,
    handleSubmit,
    setFieldValue,
    touched,
    errors,
    setFieldTouched,
    isSubmitting,
  }) => {
    const { error } = this.state;
    const { history } = this.props;

    return (
      <KeyboardAvoidingView
        style={[
          styles.view.form,
          {
            backgroundColor: 'white',
            width: '100%',
            padding: 0,
            margin: 0,
            alignItems: 'center',
            justifyContent: 'space-evenly',
          },
        ]}
        behavior="padding"
      >
        <Header
          name={translate('forgot_header')}
          hasCancel
          history={history}
        />

        <KeyboardAwareScrollView
          style={{
            flex: 1,
            width: '100%',
            margin: 0,
          }}
          contentContainerStyle={{
            width: '100%',
            padding: 0,
            alignItems: 'center',
            justifyContent: 'space-evenly',
            paddingBottom: 20,
          }}
        >
          {error !== undefined && (
            <Text
              style={{
                color: 'red',
              }}
            >
              {error}
            </Text>
          )}

          <Input
            label={translate('signin_email')}
            containerStyle={styles.form.inputContainer}
            labelStyle={styles.form.inputLabel}
            inputStyle={styles.form.inputInput}
            inputContainerStyle={touched.email && errors.email ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
            leftIconContainerStyle={styles.form.inputIconContainer}
            value={values.email}
            placeholder={translate('signin_email_placeholder')}
            autoCompleteType="email"
            textContentType="emailAddress"
            importantForAutofill="yes"
            leftIcon={(
              <Icon
                name="user"
                type="font-awesome"
                size={16}
                color={styles.form.inputLabel.color}
              />
            )}
            keyboardType="email-address"
            autoCapitalize="none"
            autoFocus
            onChangeText={(value) => setFieldValue('email', value)}
            onBlur={() => setFieldTouched('email')}
            editable={!isSubmitting}
            errorMessage={touched.email && errors.email ? errors.email : undefined}
          />
          <Input
            label={translate('confirm_code')}
            value={values.code}
            containerStyle={styles.form.inputContainer}
            labelStyle={styles.form.inputLabel}
            inputStyle={styles.form.inputInput}
            inputContainerStyle={touched.code && errors.code ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
            // leftIconContainerStyle={styles.form.inputIconContainer}
            placeholder={translate('forgot_code')}
            // leftIcon={(
            //   <Icon
            //     name="lock"
            //     type="font-awesome"
            //     size={24}
            //     color={styles.form.inputLabel.color}
            //   />
            // )}
            keyboardType="numeric"
            autoCapitalize="none"
            onChangeText={(value) => setFieldValue('code', value)}
            onBlur={() => setFieldTouched('code')}
            editable={!isSubmitting}
            errorMessage={touched.code && errors.code ? errors.code : undefined}
          />
          <Input
            label={translate('signin_password')}
            containerStyle={styles.form.inputContainer}
            labelStyle={styles.form.inputLabel}
            inputStyle={styles.form.inputInput}
            inputContainerStyle={touched.password && errors.password ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
            leftIconContainerStyle={styles.form.inputIconContainer}
            placeholder={translate('forgot_password')}
            textContentType="newPassword"
            leftIcon={(
              <Icon
                name="lock"
                type="font-awesome"
                size={16}
                color={styles.form.inputLabel.color}
              />
            )}
            secureTextEntry
            autoCapitalize="none"
            value={values.password}
            onChangeText={(value) => setFieldValue('password', value)}
            onBlur={() => setFieldTouched('password')}
            editable={!isSubmitting}
            errorMessage={touched.password && errors.password ? errors.password : undefined}
          />
          <Input
            label={translate('signup_password2')}
            containerStyle={styles.form.inputContainer}
            labelStyle={styles.form.inputLabel}
            inputStyle={styles.form.inputInput}
            inputContainerStyle={touched.password2 && errors.password2 ? styles.form.inputInputContainerError : styles.form.inputInputContainer}
            leftIconContainerStyle={styles.form.inputIconContainer}
            placeholder={translate('signup_password2_placeholder')}
            leftIcon={(
              <Icon
                name="lock"
                type="font-awesome"
                size={16}
                color={styles.form.inputLabel.color}
              />
            )}
            secureTextEntry
            autoCapitalize="none"
            value={values.password2}
            onChangeText={(value) => setFieldValue('password2', value)}
            onBlur={() => setFieldTouched('password2')}
            editable={!isSubmitting}
            errorMessage={touched.password2 && errors.password2 ? errors.password2 : undefined}
          />

          <Button
            title={translate('forgot_submit_action')}
            containerStyle={[styles.buttonfsf.primaryContainer, { marginTop: 30 }]}
            buttonStyle={styles.button.primary}
            disabledStyle={styles.button.primaryDisabled}
            titleStyle={styles.button.primaryTitle}
            disabledTitleStyle={styles.button.primaryTitleDisabled}
            onPress={handleSubmit}
            disabled={!isValid || isSubmitting}
            loading={isSubmitting}
            loadingProps={{ size: 'small', color: 'white' }}
          />
        </KeyboardAwareScrollView>
      </KeyboardAvoidingView>
    );
  }

  render() {
    const { error, email } = this.state;
    return (
      <Formik
        enableReinitialize
        initialValues={{
          error, email, code: '', password: '',
        }}
        onSubmit={this.onSubmit}
        validationSchema={validationSchema}
      >
        {this.renderForm}
      </Formik>
    );
  }
}

ForgotSubmitForm.defaultProps = {
  redirect: '/',
};

ForgotSubmitForm.propTypes = {
  redirect: PropTypes.string,
  email: PropTypes.string.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
};

export default ForgotSubmitForm;
